import { uuid } from './regex';
import { TooResidentialRoutes } from './TooResidential';

export const InsurancesRoutes = {
    path: 'insurances',
    guarantee: {
        path: 'guarantee',
        explain: {
            path: 'explain',
        },
        details: {
            path: `:psInsuranceId(${uuid})`,
            endorsement: {
                path: ':endorsementNumber(\\d+)',
            },
            installments: {
                path: 'installments',
            },
            coverages: {
                path: 'coverages',
            },
        },
    },
    residential: {
        path: 'residential',
        explain: {
            path: 'explain',
        },
        details: {
            path: `:psInsuranceId(${uuid})`,
            endorsement: {
                path: ':endorsementNumber(\\d+)',
            },
            installments: {
                path: 'installments',
            },
            coverages: {
                path: 'coverages',
            },
        },
        too: TooResidentialRoutes,
    },
    payment: {
        path: '',
        checkout: {
            path: `:resourceId(${uuid})`,
            login: { path: 'login' },
            details: { path: 'details' },
            checkout: { path: 'checkout' },
            result: { path: 'result' },
            fail: { path: 'fail' },
            policy: { path: 'policy' },
            token: { path: 'token' },
            register: { path: 'register' },
        },
        too: {
            path: 'too',
            policy: {
                path: `:resourceId(${uuid})`,
                waiting: { path: 'waiting' },
                fail: { path: 'fail' },
            },
        },
    },
};
